export enum InsightsType {
  INVESTIGATIONS = 'Investigations',
  ASSESSMENTS = 'Assessments',
}
